export default [
    {
        path: 'relatorio-estorno-saida',
        component: () => import(
            /* webpackChunkName: 'almoxarifado-relatorio-estorno-saida' */
            '@/views/almoxarifado/relatorio-estorno-saida/Index'
        ),
        redirect: 'relatorio-estorno-saida/index',
        children: [
            {
                name: 'almoxarifado-relatorio-estorno-saida-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'almoxarifado-relatorio-estorno-saida' */
                    '@/views/almoxarifado/relatorio-estorno-saida/List.vue'
                ),
            },
        ],
    },
]